import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V6.82H7.16V4.72H9.62V6.82H14.38V4.72H16.84V6.82H20.28V18.54ZM14.98 12H12.36L13.56 9.52H12.46L9.02 13.48H11.64L10.44 15.96H11.54L14.98 12Z" />
    </SvgIcon>
  );
});
